<!-- ＪリーグID入力コンポーネント -->
<template>
    <dd :class="validate.$error | klass">
        <template v-if="validate.$error">
            <span v-if="!validate.required" class="errNote">ＪリーグIDを入力してください。</span>
            <span v-if="!validate.minLength || !validate.maxLength" class="errNote">
            ＪリーグIDは{{ validate.$params.minLength.min }}文字以上{{ validate.$params.maxLength.max }}文字以下で入力してください。
        </span>
            <span v-if="!validate.jleagueIdRule" class="errNote">ＪリーグIDで使用できない文字が含まれています。</span>
            <!-- span v-if="!validate.isUnique" class="errNote">指定されたIDは使用できません。</span -->
        </template>
        <span v-if="!isUnique && !activateJleagueId" class="errNote">ＪリーグIDの重複する会員が既に存在しています。別のＪリーグIDを設定してください。</span>
        <span v-else-if="!activateJleagueId && isDuplicateJleagueId" class="errNote">ＪリーグIDの重複する会員が既に存在しています。別のＪリーグIDを設定してください。</span>
        <template v-if="isSignup">
            <input v-if="editableJleagueId || !isUnique" v-model="validate.$model"
                   @input="setUserInfoPatch"
                   name="jleague_id"
                   type="text"
                   class="regular uneditable"
                   placeholder="ＪリーグID">
            <input v-else v-model="validate.$model"
                   @input="setUserInfoPatch"
                   :readonly="readonly"
                   :disabled="disabled"
                   name="jleague_id"
                   type="text"
                   class="regular uneditable"
                   placeholder="ＪリーグID">
        </template>
        <template v-else>
            <input v-model="validate.$model"
                   @input="setUserInfoPatch"
                   :readonly="readonly"
                   :disabled="disabled"
                   name="jleague_id"
                   type="text"
                   class="regular"
                   placeholder="ＪリーグID">
        </template>
        <span v-if="!isDuplicateJleagueId || !isEmailToken">
            <span v-if="isSignup" class="annotation" style="margin-top: 6px">新規登録時にＪリーグIDは変更できません。変更する場合は、登録完了後、メインメニューの「登録内容を変更する」から変更可能です。</span>
            <span v-else class="annotation" style="margin-top: 6px">使用できる文字は半角の英字と半角数字、半角記号 @_+!*/.- です。</span>
        </span>
    </dd>
</template>

<script>
import { mixinUserInfoFieldComponent } from '../../mixin/utility'

export default {
    name: 'UserInfoJleagueIdField',
    mixins: [mixinUserInfoFieldComponent],
    data: function(){
        return {}
    },
    props: {
        validate: {
            type: Object,
            required: true
        },
        isXhr: {
            type: Boolean,
            required: true
        },
        isUnique: {
            type: Boolean,
            required: true
        },
        disabled: {
            type: Boolean,
            required: true
        },
        formName: {
            type: String,
            default: ''
        },
        isDuplicateJleagueId: {
            type: Boolean,
            required: false
        },
        isEmailToken: {
            type: Boolean,
            required: false,
            default: false
        },
        editableJleagueId: {
            type: Boolean,
            required: false
        },
        original_jleague_id: {
            type: String,
            required: true,
        },
        activateJleagueId: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        isSignup: function(){
            return this.formName === 'signup';
        },
        readonly: function(){
            // API通信中は変更できないようにする
            return this.isXhr;
        }
    },
    methods: {
        setUserInfoPatch: function(ev){
            const key = ev.target.name;
            const value = ev.target.value;
            this.$emit('set-user-info-patch', key, value);
        }
    }
}
</script>
